import { Box, Paper } from '@mui/material'
import styles from './index.module.scss'

/** Shown while lazy-loaded route chunks download (SaaS-scale bundle strategy). */
function MainRouteFallback() {
  return (
    <Box component="section" className={styles.region} aria-busy="true" aria-label="Loading workspace">
      <Paper className={styles.panel} elevation={0}>
        <Box className={styles.shimmer} />
      </Paper>
    </Box>
  )
}

export default MainRouteFallback
